import React from 'react';
import { trustPoints, translations } from '../data/mock';
import { BadgeCheck, Receipt, Clock, Wrench } from 'lucide-react';

const iconMap = {
  BadgeCheck,
  Receipt,
  Clock,
  Wrench
};

const WhyUsSection = () => {
  const t = translations.whyUs;

  return (
    <section id="why-us" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="inline-block text-sm font-semibold text-gray-500 uppercase tracking-wider mb-4">
              {t.label}
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
              {t.title}
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              {t.description}
            </p>

            {/* Trust Points */}
            <div className="space-y-6">
              {trustPoints.map((point) => {
                const IconComponent = iconMap[point.icon];
                return (
                  <div
                    key={point.id}
                    className="flex gap-4 group"
                  >
                    <div className="flex-shrink-0 w-12 h-12 bg-gray-100 group-hover:bg-gray-900 rounded-xl flex items-center justify-center transition-colors duration-300">
                      {IconComponent && (
                        <IconComponent className="w-6 h-6 text-gray-600 group-hover:text-white transition-colors duration-300" />
                      )}
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-1">
                        {point.title}
                      </h3>
                      <p className="text-gray-600">
                        {point.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative">
            <div className="bg-gray-50 rounded-3xl p-8 lg:p-12">
              {/* Stats Grid */}
              <div className="grid grid-cols-2 gap-6">
                <div className="bg-white rounded-2xl p-6 shadow-sm">
                  <div className="text-4xl font-bold text-gray-900 mb-2">0</div>
                  <div className="text-sm text-gray-500">{t.stats.diagnosticsCost}</div>
                  <div className="mt-3 text-emerald-600 font-semibold text-sm">{t.stats.alwaysFree}</div>
                </div>
                <div className="bg-white rounded-2xl p-6 shadow-sm">
                  <div className="text-4xl font-bold text-gray-900 mb-2">100%</div>
                  <div className="text-sm text-gray-500">{t.stats.transparentPricing}</div>
                  <div className="mt-3 text-gray-600 font-semibold text-sm">{t.stats.noHiddenFees}</div>
                </div>
                <div className="bg-white rounded-2xl p-6 shadow-sm">
                  <div className="text-4xl font-bold text-gray-900 mb-2">Rychle</div>
                  <div className="text-sm text-gray-500">{t.stats.turnaround}</div>
                  <div className="mt-3 text-gray-600 font-semibold text-sm">{t.stats.clearEstimates}</div>
                </div>
                <div className="bg-gray-900 rounded-2xl p-6 text-white">
                  <div className="text-4xl font-bold mb-2">Pro</div>
                  <div className="text-sm text-gray-400">{t.stats.expertTeam}</div>
                  <div className="mt-3 text-emerald-400 font-semibold text-sm">{t.stats.skilledTechnicians}</div>
                </div>
              </div>

              {/* Bottom Banner */}
              <div className="mt-8 bg-white rounded-2xl p-6 shadow-sm border border-emerald-100">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center">
                    <BadgeCheck className="w-6 h-6 text-emerald-600" />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">{t.guarantee}</p>
                    <p className="text-sm text-gray-600">{t.guaranteeDesc}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative */}
            <div className="absolute -z-10 -top-4 -right-4 w-full h-full bg-gray-200 rounded-3xl" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
